import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CloudAuthenticationService } from '../services/cloud-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  private apiVersion = environment.apiVersion;

  private refreshSubject: Subject<any> = new Subject<any>();
  private excludedUrls = [];
  constructor(private authService: CloudAuthenticationService, private router: Router) {
    this.excludedUrls = environment.excludedUrls;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.excludedUrls.find(x => req.url.endsWith(x))) {
      return next.handle((this.updateHeader(req)));
    }
    return next.handle(this.updateHeader(req)).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          const token = this.authService.getToken();
          if (!token) {
            //this.authService.logout();
            this.router.navigate([environment.constants.redirectUrl]);
          } else if (this.isTokenExpired(error)) {
            return this.handleTokenExpired().pipe(
              switchMap(() => {
                return next.handle(this.updateHeader(req));
              }),
              catchError(tokenError => {
                this.authService.logout();
                return throwError(tokenError);
              })
            );
          }
          if (error.status === 0) {
            this.authService.logout();
            this.router.navigate([environment.constants.redirectUrl]);
          }
          if (error.error === 'authcode not valid') {
            this.authService.logout();
          }
        } else {
          return throwError(error);
        }
        return throwError(error);
      })
    );
  }

  handleTokenExpired() {
    this.refreshSubject.subscribe({
      complete: () => {
        this.refreshSubject = new Subject<any>();
      }
    });
    if (this.refreshSubject.observers.length === 1) {
      this.authService.refreshToken().
        pipe(
          catchError(error => {
            throw error;
          })).
        subscribe(this.refreshSubject);
    }
    return this.refreshSubject;
  }

  isTokenExpired(error: HttpErrorResponse): boolean {
    return error.status && error.status === 401;
  }

  updateHeader(req: HttpRequest<any>) {
    const token = this.authService.getToken();

    req = req.clone({
      setParams: { 'api-version': this.apiVersion }
    });

    if (token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }
    return req;
  }
}
